import { InsightLayout } from '@/features/(insight)/insight-layout';
import { createFileRoute } from '@tanstack/react-router';

import z from 'zod';

const searchSchema = z.object({
  q: z.string(),
});

export const Route = createFileRoute('/workspace/$workspaceId/insight')({
  validateSearch: searchSchema,
  component: InsightLayout,
});
